import {Component, inject, OnDestroy, OnInit} from "@angular/core";
import {Store} from "@ngrx/store";
import {FormBuilder, Validators} from "@angular/forms";
import {GeneralPartnerActions} from "../../../store/fund.actions";
import {
    selectGeneralPartnerCommentContext,
    selectGeneralPartnerFormisEditable,
    selectSelectedGeneralPartner
} from "../../../store/general-partner/general-partner.selectors";
import {noWhitespaceValidator} from "../../../../shared/utils/form-validators";
import {map, Subscription} from "rxjs";
import {selectIsAnyFundFormInEditMode} from "../../../store/fund/fund.selectors";
import {CodeTableEnum} from "../../../../shared/model/code";
import {Router} from "@angular/router";
import {EMPTY_GENERAL_PARTNER} from "../../../models/general-partner";

@Component({
    selector: "valumize-general-partner-details",
    templateUrl: "./general-partner-details.component.html",
    styleUrls: ["./general-partner-details.component.scss"],
    standalone: false
})
export class GeneralPartnerDetailsComponent implements OnInit, OnDestroy {
    private readonly store = inject(Store);
    private readonly formBuilder = inject(FormBuilder);
    private readonly router = inject(Router);

    codeTableGpQuality = CodeTableEnum.FUND_GENERALPARTNERQUALITY;

    subscriptions: Subscription[] = [];
    isEditable = false;
    generalPartner = EMPTY_GENERAL_PARTNER;

    commentContext$ = this.store.select(selectGeneralPartnerCommentContext);
    isEditDisabled$ = this.store.select(selectIsAnyFundFormInEditMode);

    generalPartnerForm = this.formBuilder.group({
        name: this.formBuilder.control<string>("", {nonNullable: true, validators: [Validators.required, Validators.maxLength(100), noWhitespaceValidator()]}),
        quality: this.formBuilder.control<string>("", {nonNullable: true, validators: [Validators.required, noWhitespaceValidator()]}),
        comment: this.formBuilder.control("", {nonNullable: true}),
    });

    constructor( ) {
    }

    ngOnInit() {
        this.subscriptions.push(this.store.select(selectSelectedGeneralPartner).pipe(map((generalPartner) => {
            this.generalPartner = generalPartner;
            this.generalPartnerForm.patchValue({
                name: generalPartner.name.text,
                quality: generalPartner.quality.code,
                comment: generalPartner.comment.text
            });
        })).subscribe());

        this.subscriptions.push(this.store.select(selectGeneralPartnerFormisEditable).pipe(map((isEditable) => {
            this.isEditable = isEditable;
        })).subscribe());
    }

    navigateToFund(event: any){
        this.router.navigate(["/funds", event.id]);
    }

    editMode = () => this.store.dispatch(GeneralPartnerActions.edit());

    cancel = () => this.store.dispatch(GeneralPartnerActions.cancel());

    save() {
        if (this.generalPartnerForm.valid) {
            this.store.dispatch(GeneralPartnerActions.save({
                    generalPartner: {
                        ...this.generalPartner,
                        id: this.generalPartner.id,
                        name: {
                            ...this.generalPartner.name,
                            text: this.generalPartnerForm.controls.name.value
                        },
                        quality: {
                            ...this.generalPartner.quality,
                            code: this.generalPartnerForm.controls.quality.value
                        },
                        comment: {
                            ...this.generalPartner.comment,
                            text: this.generalPartnerForm.controls.comment.value
                        }
                    }
                }
            ));
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
